const workData = [
    {
        image: "https://cdn.pixabay.com/photo/2016/11/29/13/20/balloons-1869790_960_720.jpg",
        name: "Our Events",
        description: "Events, Meetings etc",
        link: "#",
    },
    {
        image: "https://cdn.pixabay.com/photo/2015/01/10/17/32/physiotherapy-595529_960_720.jpg",
        name: "Our Health Box",
        description: "ORGANIC F&B STORE",
        link: "#"
    },
    {
        image: "https://cdn.pixabay.com/photo/2019/12/14/08/36/shopping-4694470_960_720.jpg",
        name: "The Amples",
        description: "BEST OF AMAZON PRODUCTS",
        link: "#",
    },
    {
        image: "https://cdn.pixabay.com/photo/2014/04/05/11/40/diamond-316611_960_720.jpg",
        name: "House Art",
        description: "ARTEFACTS, GEMS & JEWELLERY",
        link: "#",
    },
    {
        image: "https://cdn.pixabay.com/photo/2015/07/31/15/01/security-869216_960_720.jpg",
        name: "Nezox Shield",
        description: "FACILITIES MANAGEMENT",
        link: "#",
    },
]

export default workData